import { useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import CustomAlert from "../../Common/CustomAlert"
import Loading from "../../Common/Loading"

interface School {
    school_code: string
    name: string
    address: string
    country: string
    state: string
    phone_no: string
    email: string
    category: string
    trial_school: boolean
    tutor_center: boolean
    dlr_or_ho: boolean
    max_users: string
    max_seats: string
    mds_available: string
    send_reports_to_parent: boolean
    eligible_for_incentives: boolean
    status: string
    expiry_date: string
    curriculum: string
    authenticate_ip: boolean
    allow_direct_home_use: boolean
    allow_home_work: boolean
    school_can_access_from_anywhere: boolean
    access_start_date: string
    access_end_date: string
    access_from_time: string
    access_to_time: string
    access_on: string
    merchant_code: string
    merchant_key: string
    change_lib_to_school: boolean
}

interface Product {
    prod_id: number
    prod_desc: string
    subject: string
    country: string
    curriculum: string
    no_of_lic_purchased: number | null
}

interface IP {
    id: number
    start_ip: string
    end_ip: string
    start_ip_address: string
    end_ip_address: string
}

interface Country {
    value: string
    text: string
}

interface StateItem { state: string }

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const

function isValidDate(val: string): boolean {
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(val)) return false
    const [d, m, y] = val.split("/").map(Number)
    const dt = new Date(y, m - 1, d)
    return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d
}

function isValidTime(val: string): boolean {
    // HH:mm
    if (!/^\d{2}:\d{2}$/.test(val)) return false
    const [h, m] = val.split(":").map(Number)
    return h >= 0 && h <= 23 && m >= 0 && m <= 59
}

function getEntityName(category: string): string {
    if (category === "DLR") return "Dealer"
    if (category === "ISP") return "ISP"
    return "School"
}

function getMaxUsersLabel(category: string): string {
    if (category === "SCH") return "Max Students / Max Seats"
    if (category === "LIB") return "Max. Students / Max Seats"
    if (category === "ISP") return "Max. Families / Max Seats"
    return "Max. Users"
}

document.body.style.backgroundColor = "#fff";
// ─── CSS (matching eLearnCSS.css faithfully) ──────────────────────────────────

const css = `
  * { box-sizing: border-box; }
  body { font-family: 'Trebuchet MS', sans-serif; font-size: 10pt; margin: 0; background: #fff; }

  .cssContentTitle {
    background-color: #2f6089; color: White; height: 29px;
    font-size: 9pt; font-family: 'Trebuchet MS'; padding-left: 7px;
   align-items: center;
  }
  .cssLabelMandatory {
    background-color: #000080; color: White; height: 29px;
    font-size: 10pt; font-family: 'Trebuchet MS'; padding-left: 7px;
    display: flex; align-items: center; white-space: nowrap;width:500px;
  }
  .cssLabelOptional {
    background-color: #5588bb; color: White; height: 29px;
    font-size: 9pt; font-family: 'Trebuchet MS'; padding-left: 7px;
    display: flex; align-items: center;
  }
  .cssTextBox {
    font-family: 'Trebuchet MS'; font-size: 11pt;
    border: solid 1px #006600; padding-left: 5px;
    height: 24px; width: 100%;
  }
  .cssTextBoxReadOnly {
    font-family: 'Trebuchet MS'; font-size: 11pt;
    border: solid 1px gray; padding-left: 5px;
    height: 24px; background-color: lightgray;
  }
  .cssDropDown {
    font-family: 'Trebuchet MS'; font-size: 11pt; width: 100%;
    height: 24px; border: solid 1px #006600;
  }
  .cssButton {
    background-color: #119ECC; font-family: 'Trebuchet MS'; font-size: 8pt;
    color: White; border: none; height: 20px; width: 80px; cursor: pointer;
  }
  .cssButtonForAdmin {
    background-color: transparent; font-family: 'Trebuchet MS'; font-size: 10pt;
    color: blue; border: none; height: 20px; width: 40px;
    cursor: pointer; text-decoration: underline; padding: 0 4px;
  }
  .cssButtonWithBorder {
    background-color: #119ECC; font-family: 'Trebuchet MS'; font-size: 10pt;
    font-weight: bold; color: White; border: solid 2px orange;
    height: 28px; width: 80px; cursor: pointer;
  }
  .cssGridViewHeader {
    font-family: 'Trebuchet MS'; font-size: 8pt;
    background-color: #2f6089; color: White; font-weight: normal;
    padding: 3px; text-align: left;
  }
  .cssGridView {
    font-family: 'Trebuchet MS'; font-size: 8pt;
    color: black; border-collapse: collapse; width: 86%;
  }
  .cssGridRow {
    background-color: white; vertical-align: top; cursor: pointer;
  }
  .cssGridAltRow {
    background-color: #EFF3FB; cursor: pointer;
  }
  .cssGridSelRow {
    background-color: blue !important; color: White !important;
  }
  td { padding: 2px 3px; }
  .aclSection { background-color: #ffffcc; }
  .updateMsg {
    color: green; font-weight: bold; font-family: 'Trebuchet MS'; font-size: 9pt;
    padding: 4px 8px;
  }
  .errorMsg {
    color: red; font-weight: bold; font-family: 'Trebuchet MS'; font-size: 9pt;
    padding: 4px 8px;
  }

  /* Products panel */
  #divProd {
    width: 100%; height: 510px; overflow: auto; background-color: #eeeeff;
  }
  #divProd table { border-collapse: collapse; width: 97%; }
  #divProd td, #divProd th { padding: 5px; font-family: 'Trebuchet MS'; font-size: 10pt; }
  #divProd .prodHeader { background-color: #ccccff;}

  /* Main layout */
  .mainTable { width: 100%; border: solid 1px blue; border-collapse: collapse; }
  .mainTable > tbody > tr > td { vertical-align: top; }
  .leftCol { width: 40%; }
  .rightCol { width: 60%; border-left: solid 1px #ccc; }
  .innerTable { width: 100%; border-collapse: collapse; }
  .innerTable td { border-bottom: solid 1px #e0e0e0; }
  .labelCol { width: 100%; }
  .valueCol { width: 65%; padding: 2px 4    px; }

  .bottomBar { text-align: center; height: 30px; padding: 4px; }
`

// ─── Component ────────────────────────────────────────────────────────────────

export default function EL_SchoolDetails() {
    const schoolCode = new URLSearchParams(window.location.search).get("SchoolCode") ?? ""
    const calledFrom = new URLSearchParams(window.location.search).get("CalledFrom") ?? ""
    const navigate = useNavigate()

    // ── State ──
    const [school, setSchool] = useState<School>({
        school_code: "",
        name: "",
        address: "",
        country: "",
        state: "",
        phone_no: "",
        email: "",
        category: "SCH",
        trial_school: false,
        tutor_center: false,
        dlr_or_ho: false,
        max_users: "",
        max_seats: "",
        mds_available: "",
        send_reports_to_parent: false,
        eligible_for_incentives: false,
        status: "A",
        expiry_date: "",
        curriculum: "",
        authenticate_ip: false,
        allow_direct_home_use: false,
        allow_home_work: false,
        school_can_access_from_anywhere: false,
        access_start_date: "",
        access_end_date: "",
        access_from_time: "",
        access_to_time: "",
        access_on: "NNNNNNN",
        merchant_code: "",
        merchant_key: "",
        change_lib_to_school: false
    })

    const [products, setProducts] = useState<Product[]>([])
    const [ips, setIps] = useState<IP[]>([])
    const [countries, setCountries] = useState<Country[]>([])
    const [states, setStates] = useState<StateItem[]>([])

    const [showAllProducts, setShowAllProducts] = useState(true)
    const [selectedIPId, setSelectedIPId] = useState<number | null>(null)
    const [selectedIPRow, setSelectedIPRow] = useState<number | null>(null)

    const [updateMessage, setUpdateMessage] = useState("")
    const [errorMsg, setErrorMsg] = useState("")
    const [unauthorised, setUnauthorised] = useState("")
    const [showAlert, setShowAlert] = useState(false);

    const [loadingCount, setLoadingCount] = useState(0)

    const isLoading = loadingCount > 0

    const startLoading = () => {
        setLoadingCount(prev => prev + 1)
    }

    const stopLoading = () => {
        setLoadingCount(prev => Math.max(0, prev - 1))
    }

    document.body.style.backgroundColor = "#fff"

    // ── Load on mount ──
    useEffect(() => {
        loadSchool()
        loadIPs()
        // countries loaded inside loadSchool after we know curriculum
    }, [])

    async function loadSchool() {
        startLoading()

        try {
            const res = await fetch(`${API_BASE_URL}api/school/${schoolCode}/`)

            if (!res.ok) {
                throw new Error("Not found")
            }

            const data = await res.json()

            // Map flat DB fields → state
            const s: School = {
                school_code: data.school_code ?? "",
                name: data.name ?? "",
                address: data.address ?? "",
                country: data.country ?? "",
                state: data.state ?? "",
                phone_no: data.phone_no ?? "",
                email: data.email ?? "",
                category: data.category ?? "",
                trial_school: data.trial_school === "Y",
                tutor_center: data.tutor_center === "Y",
                dlr_or_ho: data.dlr_or_ho === "HO",
                max_users: data.max_users != null ? String(data.max_users) : "",
                max_seats: data.max_seats != null ? String(data.max_seats) : "",
                mds_available:
                    data.mds_available != null && data.mds_available !== 0
                        ? String(data.mds_available)
                        : "",
                send_reports_to_parent: data.send_reports_to_parent === "Y",
                eligible_for_incentives: data.eligible_for_incentives === "Y",
                status: data.status === "A" ? "A" : "N",
                expiry_date: data.user_expiry_date_if_lib
                    ? formatDateForDisplay(data.user_expiry_date_if_lib)
                    : "",
                curriculum: data.curriculum ?? "",
                authenticate_ip: data.authenticate_ip === "Y",
                allow_direct_home_use: data.allow_direct_home_use === "Y",
                allow_home_work: data.allow_home_work === "Y",
                school_can_access_from_anywhere:
                    data.school_can_access_from_anywhere === "Y",
                access_start_date: data.access_start_date
                    ? formatDateForDisplay(data.access_start_date)
                    : "",
                access_end_date: data.access_end_date
                    ? formatDateForDisplay(data.access_end_date)
                    : "",
                access_from_time: data.access_from_time ?? "",
                access_to_time: data.access_to_time ?? "",
                access_on: data.access_on ?? "NNNNNNN",
                merchant_code: data.ipay88_merchant_code ?? "",
                merchant_key: data.ipay88_merchant_key ?? "",
                change_lib_to_school: false
            }

            setSchool(s)

            // These are dependent on school data
            await loadCountries()
            await loadStates(s.country, s.state)
            await loadProducts(s.curriculum)

        } catch (e) {
            console.error("Failed to load school details:", e)
            setErrorMsg("Failed to load school details")
        } finally {
            stopLoading()
        }
    }

    function formatDateForDisplay(dbDate: string): string {
        // DB: MM/dd/yyyy or ISO → display: dd/MM/yyyy
        try {
            const d = new Date(dbDate)
            if (isNaN(d.getTime())) return dbDate
            return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`
        } catch { return dbDate }
    }

    async function loadCountries() {
        startLoading()

        try {
            const res = await fetch(`${API_BASE_URL}api/countries/`)

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`)
            }

            const data = await res.json()

            const formatted = data.map((item: any) => ({
                value: item.Major,
                text: item.Major
            }))

            setCountries(formatted)

        } catch (err) {
            console.error("Failed loading countries:", err)
        } finally {
            stopLoading()
        }
    }

    async function loadStates(country: string, selectedState: string = "") {
        if (!country) {
            setStates([])
            return
        }

        startLoading()

        try {
            const res = await fetch(
                `${API_BASE_URL}api/get_states_country/?country=${encodeURIComponent(country)}`
            )

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`)
            }

            const data = await res.json()

            const statesArray = Array.isArray(data) ? data : []

            const formatted = statesArray
                .map((s: any) => {
                    const value =
                        typeof s === "string"
                            ? s
                            : s?.state ?? s?.State ?? ""

                    return {
                        state: String(value).trim()
                    }
                })
                .filter((s: StateItem) => s.state !== "")

            // Make sure the school's actual saved State is available
            // even when it is missing from the EL_States API response.
            const trimmedSelectedState = selectedState.trim()

            if (
                trimmedSelectedState &&
                !formatted.some(
                    s => s.state.toLowerCase() === trimmedSelectedState.toLowerCase()
                )
            ) {
                formatted.push({
                    state: trimmedSelectedState
                })
            }

            // Keep the same alphabetical ordering as the VB query.
            formatted.sort((a, b) =>
                a.state.localeCompare(b.state)
            )

            setStates(formatted)

        } catch (err) {
            console.error("Failed loading states:", err)

            // Even if the states API fails, don't lose the school's
            // existing State value.
            if (selectedState.trim()) {
                setStates([{ state: selectedState.trim() }])
            } else {
                setStates([])
            }
        } finally {
            stopLoading()
        }
    }

    async function loadProducts(curriculum: string) {
        startLoading()

        try {
            const res = await fetch(
                `${API_BASE_URL}api/school-products/${schoolCode}/?curriculum=${encodeURIComponent(curriculum)}`
            )

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`)
            }

            const data = await res.json()

            setProducts(Array.isArray(data) ? data : [])

        } catch (err) {
            console.error("Failed loading products:", err)
            setProducts([])
        } finally {
            stopLoading()
        }
    }
    async function loadIPs() {
        startLoading()

        try {
            const res = await fetch(
                `${API_BASE_URL}api/school-ips/${schoolCode}/`
            )

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`)
            }

            const data = await res.json()

            setIps(Array.isArray(data) ? data : [])
            setSelectedIPId(null)
            setSelectedIPRow(null)

        } catch (err) {
            console.error("Failed loading IPs:", err)
            setIps([])
        } finally {
            stopLoading()
        }
    }

    // ── Field change ──
    function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        const { name, value, type } = e.target
        const checked = (e.target as HTMLInputElement).checked
        setSchool(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }))
    }

    function handleCountryChange(e: React.ChangeEvent<HTMLSelectElement>) {
        const country = e.target.value

        setSchool(prev => ({
            ...prev,
            country,
            state: ""
        }))

        loadStates(country, "")
    }

    // ── Access_On helpers ──
    function isDayChecked(idx: number): boolean {
        return (school.access_on ?? "NNNNNNN")[idx] === "Y"
    }

    function setDay(idx: number, checked: boolean) {
        const arr = (school.access_on ?? "NNNNNNN").split("")
        arr[idx] = checked ? "Y" : "N"
        setSchool(prev => ({ ...prev, access_on: arr.join("") }))
    }

    // ── Products toggle: all / selected only ──
    function toggleProductAssignment(prodId: number, checked: boolean) {
        setProducts(prev => prev.map(p =>
            p.prod_id === prodId
                ? { ...p, no_of_lic_purchased: checked ? 1 : null }
                : p
        ))
    }

    // ── IP row click (matches fn_Select in VB JS) ──
    function selectIPRow(idx: number, id: number) {
        setSelectedIPRow(idx)
        setSelectedIPId(id)
    }

    // ── Validation (mirrors fn_validate JS) ──
    function validate(): boolean {
        if (school.category === "SCH") {
            if (parseInt(school.max_users) < parseInt(school.max_seats)) {
                window.alert("MaxSeats should not be more than MaxUsers")
                return false
            }
        }
        if (school.access_start_date.trim() !== "" && !isValidDate(school.access_start_date)) {
            window.alert("Invalid Access From date")
            return false
        }
        if (school.access_end_date.trim() !== "" && !isValidDate(school.access_end_date)) {
            window.alert("Invalid Access to date")
            return false
        }
        if (school.access_from_time.trim() !== "" && !isValidTime(school.access_from_time)) {
            window.alert("Invalid Access from time")
            return false
        }
        if (school.access_to_time.trim() !== "" && !isValidTime(school.access_to_time)) {
            window.alert("Invalid Access to time")
            return false
        }
        return true
    }

    // ── Save (mirrors btnSave_Click) ──
    async function handleSave() {
        if (!validate()) return

        setUpdateMessage("")
        setErrorMsg("")

        startLoading()

        try {
            const selectedProductIds = products
                .filter(p => p.no_of_lic_purchased !== null)
                .map(p => p.prod_id)

            const payload = {
                name: school.name,
                address: school.address,
                phone_no: school.phone_no,
                email: school.email,
                country: school.country,
                state: school.state,
                curriculum: school.curriculum,
                category: school.category,
                status: school.status,
                trial_school: school.trial_school ? "Y" : null,
                tutor_center: school.tutor_center ? "Y" : null,
                dlr_or_ho: school.dlr_or_ho ? "HO" : null,
                max_users: school.max_users ? parseInt(school.max_users) : 0,
                max_seats: school.max_seats ? parseInt(school.max_seats) : 0,
                mds_available: school.mds_available
                    ? parseInt(school.mds_available)
                    : 0,
                send_reports_to_parent:
                    school.send_reports_to_parent ? "Y" : null,
                eligible_for_incentives:
                    school.eligible_for_incentives ? "Y" : null,
                user_expiry_date_if_lib: school.expiry_date || null,
                authenticate_ip: school.authenticate_ip ? "Y" : null,
                allow_direct_home_use:
                    school.allow_direct_home_use ? "Y" : null,
                allow_home_work: school.allow_home_work ? "Y" : null,
                school_can_access_from_anywhere:
                    school.school_can_access_from_anywhere ? "Y" : null,
                access_start_date: school.access_start_date || null,
                access_end_date: school.access_end_date || null,
                access_from_time: school.access_from_time || "00:00",
                access_to_time: school.access_to_time || "23:59",
                access_on: school.access_on,
                ipay88_merchant_code: school.merchant_code || null,
                ipay88_merchant_key: school.merchant_key || null,
                change_lib_to_school: school.change_lib_to_school,
                selected_product_ids: selectedProductIds
            }

            const res = await fetch(
                `${API_BASE_URL}api/school/update/${school.school_code}/`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }
            )

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`)
            }

            setUpdateMessage("Records Updated")
            setShowAlert(true)

            // Refresh school details
            await loadSchool()

        } catch (err) {
            console.error("Save failed:", err)
            setErrorMsg("Save failed. Please try again.")
        } finally {
            stopLoading()
        }
    }

    function handleCancel() {
        if (calledFrom === "S") {
            navigate("/SysAdmin");
        } else if (calledFrom === "L") {
            navigate("/WebAdmin/SCHOOLS/EL_ListSchools");
        } else {
            navigate("/WebAdmin/SCHOOLS/EL_ListSchools");
        }
    }

    async function handleDeleteIP() {
        if (selectedIPId === null) {
            window.alert("Select a row before deleting")
            return
        }

        if (!window.confirm("Are you sure you want to delete?")) {
            return
        }

        startLoading()

        try {
            const res = await fetch(
                `${API_BASE_URL}api/delete-ip/${selectedIPId}/`,
                {
                    method: "DELETE"
                }
            )

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`)
            }

            await loadIPs()

        } catch (err) {
            console.error("Failed deleting IP:", err)
            setErrorMsg("Failed to delete IP. Please try again.")
        } finally {
            stopLoading()
        }
    }

    function handleAddIP() {
        window.location.href = `/WEBADMIN/SCHOOLS/EL_SchoolIPs?SchoolCode=${schoolCode}`
    }

    function handleEditIP() {
        if (selectedIPId === null) { window.alert("Select a row before editing"); return }
        window.location.href = `/WEBADMIN/SCHOOLS/EL_SchoolIPs?IPID=${selectedIPId}&SchoolCode=${schoolCode}`
    }

    // function selectCurriculum() {
    //     const url = `/WEBADMIN/SCHOOLS/EL_SelectCurriculum?SchoolCode=${schoolCode}&Curriculum=${encodeURIComponent(school.curriculum)}`
    //     const win = window.open(url, "Curriculums", "width=450,height=500,resizable=no,status=no")
    //     // Listen for return value (fn_BackFromSelectCurriculum pattern)
    //     const handler = (e: MessageEvent) => {
    //         if (e.data && e.data.curriculum) {
    //             setSchool(prev => ({ ...prev, curriculum: e.data.curriculum }))
    //             loadProducts(e.data.curriculum)
    //             window.removeEventListener("message", handler)
    //         }
    //     }
    //     window.addEventListener("message", handler)
    // }
    function selectCurriculum() {
        const url =
            `/WEBADMIN/SCHOOLS/EL_SelectCurriculum` +
            `?SchoolCode=${encodeURIComponent(schoolCode)}` +
            `&Curriculum=${encodeURIComponent(school.curriculum || "")}`;

        const handler = (e: MessageEvent) => {
            // Only accept messages from our own application
            if (e.origin !== window.location.origin) return;

            if (e.data && e.data.curriculum) {
                const curriculum = e.data.curriculum;

                setSchool(prev => ({
                    ...prev,
                    curriculum
                }));

                loadProducts(curriculum);

                window.removeEventListener("message", handler);
            }
        };

        // IMPORTANT: register listener BEFORE opening popup
        window.addEventListener("message", handler);

        const width = 450;
        const height = 550;

        const screenLeft = window.screenLeft ?? window.screenX ?? 0;
        const screenTop = window.screenTop ?? window.screenY ?? 0;
        const screenWidth =
            window.innerWidth ??
            document.documentElement.clientWidth ??
            window.screen.width;
        const screenHeight =
            window.innerHeight ??
            document.documentElement.clientHeight ??
            window.screen.height;

        const left = screenLeft + (screenWidth - width) / 2;
        const top = screenTop + (screenHeight - height) / 2;

        const win = window.open(
            url,
            "Curriculums",
            `width=${width},height=${height},left=${left},top=${top},resizable=no,status=no,scrollbars=no,menubar=no,toolbar=no,location=no`
        );

        // Popup blocked
        if (!win) {
            window.removeEventListener("message", handler);
            window.alert("Please allow popups for this site.");
            return;
        }

        win.focus();
    }
    const cat = school.category
    const isSchool = cat === "SCH"
    const isLib = cat === "LIB"
    const isISP = cat === "ISP"
    const isDLR = cat === "DLR"
    const showACL = isSchool || isLib
    const showIP = school.category === "SCH" || school.category === "LIB"
    const showMaxSeats = true
    const showIncentives = isSchool
    const showMDs = isSchool
    const showTutorCenter = isSchool
    const showHO = isDLR
    const showDealer = isDLR
    const entityName = getEntityName(cat)
    const maxUsersLabel = getMaxUsersLabel(cat)

    if (unauthorised) {
        return <div style={{ padding: 20, color: "red" }}>{unauthorised}</div>
    }

    const visibleProducts = showAllProducts
        ? products
        : products.filter(p => p.no_of_lic_purchased !== null)

    return (
        <>
            <style>{css}</style>
            {isLoading && <Loading />}
            {showAlert && (
                <CustomAlert
                    message={updateMessage}
                    onClose={() => {
                        setShowAlert(false);
                        setUpdateMessage("");
                    }}
                />
            )}

            <table className="mainTable" cellPadding={0} cellSpacing={1} style={{ width: "100%" }}>
                <tbody>
                    {/* Header row */}
                    <tr style={{ width: "100%" }}>
                        <td colSpan={2} className="cssContentTitle" style={{ width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>

                                <span style={{ width: "40%" }}>{entityName} Details</span>
                                <span style={{ width: "1px", height: "28px", backgroundColor: "white" }}></span>
                                &nbsp;&nbsp;&nbsp;
                                <div>
                                    Products&nbsp;&nbsp;&nbsp;&nbsp; Show&nbsp;

                                    <input
                                        type="radio"
                                        id="rdoAll"
                                        name="ProductsSelection"
                                        checked={showAllProducts}
                                        onChange={() => setShowAllProducts(true)}
                                    />{" "}
                                    ALL Products&nbsp;&nbsp;&nbsp;

                                    <input
                                        type="radio"
                                        id="rdoSel"
                                        name="ProductsSelection"
                                        checked={!showAllProducts}
                                        onChange={() => setShowAllProducts(false)}
                                    />{" "}
                                    Assigned Products
                                </div>

                            </div>
                        </td></tr>

                    <tr>
                        <td className="leftCol" valign="top">
                            <table className="innerTable" cellPadding={0} cellSpacing={1}>
                                <tbody>

                                    {/* School Code + Trial School */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">{entityName} Code:</td>
                                        <td className="valueCol">
                                            <input
                                                className="cssTextBoxReadOnly"
                                                value={school.school_code} readOnly
                                                style={{ width: "47%" }}
                                            />
                                            &nbsp;&nbsp;
                                            <label>
                                                <input
                                                    type="checkbox" name="trial_school"
                                                    checked={school.trial_school}
                                                    onChange={handleChange}
                                                /> Trial School
                                            </label>
                                        </td>
                                    </tr>

                                    {/* Name */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">{entityName} Name:</td>
                                        <td className="valueCol">
                                            <input
                                                className="cssTextBox" name="name"
                                                value={school.name} maxLength={50}
                                                onChange={handleChange} style={{ width: "97%" }}
                                            />
                                        </td>
                                    </tr>

                                    {/* Address */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">Address:</td>
                                        <td className="valueCol">
                                            <input
                                                className="cssTextBox" name="address"
                                                value={school.address} maxLength={80}
                                                onChange={handleChange} style={{ width: "97%" }}
                                            />
                                        </td>
                                    </tr>

                                    {/* Country */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">Country:</td>
                                        <td className="valueCol">
                                            <select
                                                className="cssDropDown"
                                                value={school.country}
                                                onChange={handleCountryChange}
                                                disabled={calledFrom === "L" || calledFrom === "S"}
                                                style={{
                                                    width: "99%",
                                                    backgroundColor: calledFrom === "L" ? "#e9ecef" : "",
                                                    cursor: calledFrom === "L" ? "not-allowed" : "pointer",
                                                }}
                                            >
                                                {/* <option value="">-- Select --</option> */}
                                                {countries.map((c) => (
                                                    <option key={c.value} value={c.value}>
                                                        {c.text}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>

                                    {/* State */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">State:</td>
                                        <td className="valueCol">
                                            <select
                                                className="cssDropDown"
                                                name="state"
                                                value={school.state}
                                                onChange={handleChange}
                                                style={{ width: "99%" }}
                                            >
                                                <option value="">-- Select --</option>
                                                {states.map((s, i) => (
                                                    <option key={i} value={s.state}>
                                                        {s.state}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>

                                    {/* Phone */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">Phone Number:</td>
                                        <td className="valueCol">
                                            <input
                                                className="cssTextBox" name="phone_no"
                                                value={school.phone_no} maxLength={50}
                                                onChange={handleChange} style={{ width: "97%" }}
                                            />
                                        </td>
                                    </tr>

                                    {/* Email */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">E-mail:</td>
                                        <td className="valueCol">
                                            <input
                                                className="cssTextBox" name="email"
                                                value={school.email} maxLength={50}
                                                onChange={handleChange} style={{ width: "97%" }}
                                            />
                                        </td>
                                    </tr>

                                    {/* Category + HO + TutorCenter */}
                                    <tr>
                                        <td className="labelCol cssLabelOptional">Category:</td>
                                        <td className="valueCol">
                                            <input
                                                className="cssTextBoxReadOnly" value={school.category}
                                                readOnly maxLength={3}
                                                style={{ width: "27%", backgroundColor: "lightgray" }}
                                            />
                                            &nbsp;&nbsp;
                                            {showHO && (
                                                <label>
                                                    <input
                                                        type="checkbox" name="dlr_or_ho"
                                                        checked={school.dlr_or_ho}
                                                        onChange={handleChange}
                                                    /> Head Office
                                                </label>
                                            )}
                                            &nbsp;&nbsp;
                                            {showTutorCenter && (
                                                <label>
                                                    <input
                                                        type="checkbox" name="tutor_center"
                                                        checked={school.tutor_center}
                                                        onChange={handleChange}
                                                    /> Tutor Center
                                                </label>
                                            )}
                                            {isLib && (
                                                <label style={{ marginLeft: 8 }}>
                                                    <input
                                                        type="checkbox" name="change_lib_to_school"
                                                        checked={school.change_lib_to_school}
                                                        onChange={e => {
                                                            const checked = e.target.checked
                                                            setSchool(prev => ({ ...prev, change_lib_to_school: checked }))
                                                        }}
                                                    /> Change to School
                                                </label>
                                            )}
                                        </td>
                                    </tr>

                                    {/* Curriculum */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">
                                            <span
                                                style={{ textDecoration: "underline", cursor: "pointer" }}
                                                onClick={selectCurriculum}
                                            >Curriculum(s):</span>
                                        </td>
                                        <td className="valueCol">
                                            <input
                                                className="cssTextBox" name="curriculum"
                                                value={school.curriculum} maxLength={300}
                                                readOnly
                                                style={{ width: "97%", backgroundColor: "lightgray" }}
                                            />
                                        </td>
                                    </tr>

                                    {/* Max Users / Max Seats */}
                                    {(isSchool || isLib || isISP || isDLR) && (
                                        <tr id="trMaxUsers"
                                            style={{ display: isLib && school.change_lib_to_school ? "" : "" }}
                                        >
                                            <td className="labelCol cssLabelMandatory">{maxUsersLabel}:</td>
                                            <td className="valueCol">
                                                <input
                                                    className="cssTextBox" name="max_users"
                                                    value={school.max_users} maxLength={4}
                                                    onChange={handleChange} style={{ width: "40%" }}
                                                />
                                                {(isSchool || isLib || isISP || isDLR) && (
                                                    <>
                                                        &nbsp;/&nbsp;
                                                        <input
                                                            className="cssTextBox" name="max_seats"
                                                            value={school.max_seats} maxLength={4}
                                                            onChange={handleChange} style={{ width: "40%" }}
                                                        />
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    )}

                                    {/* Eligible for Incentives (SCH only) */}
                                    {showIncentives && (
                                        <tr>
                                            <td className="labelCol cssLabelMandatory">Eligible for Incentives:</td>
                                            <td className="valueCol">
                                                <input
                                                    type="checkbox" name="eligible_for_incentives"
                                                    checked={school.eligible_for_incentives}
                                                    onChange={handleChange}
                                                />
                                            </td>
                                        </tr>
                                    )}

                                    {/* MDs Available (SCH only) */}
                                    {showMDs && (
                                        <tr>
                                            <td className="labelCol cssLabelMandatory">MDs Available:</td>
                                            <td className="valueCol">
                                                <input
                                                    className="cssTextBox" name="mds_available"
                                                    value={school.mds_available} maxLength={4}
                                                    onChange={handleChange} style={{ width: "25%" }}
                                                />
                                                &nbsp;
                                                <label>
                                                    <input
                                                        type="checkbox" name="send_reports_to_parent"
                                                        checked={school.send_reports_to_parent}
                                                        onChange={handleChange}
                                                    /> Send Reports to parent
                                                </label>
                                            </td>
                                        </tr>
                                    )}

                                    {/* Expiry Date (hidden in original, keep but hide) */}
                                    <tr style={{ display: "none" }}>
                                        <td className="labelCol cssLabelMandatory">Expiry Date for LIB:</td>
                                        <td className="valueCol">
                                            <input
                                                className="cssTextBox" name="expiry_date"
                                                value={school.expiry_date} maxLength={20}
                                                onChange={handleChange} style={{ width: "97%" }}
                                            />
                                        </td>
                                    </tr>

                                    {/* Status */}
                                    <tr>
                                        <td className="labelCol cssLabelMandatory">Status:</td>
                                        <td className="valueCol" style={{ border: "solid 1px gray" }}>
                                            <label style={{ marginRight: 12 }}>
                                                <input
                                                    type="radio" name="status" value="A"
                                                    checked={school.status === "A"}
                                                    onChange={handleChange}
                                                /> Active
                                            </label>
                                            <label>
                                                <input
                                                    type="radio" name="status" value="N"
                                                    checked={school.status === "N"}
                                                    onChange={handleChange}
                                                /> InActive
                                            </label>
                                        </td>
                                    </tr>

                                    {/* iPay88 — DLR only */}
                                    {showDealer && (
                                        <>
                                            <tr>
                                                <td className="labelCol cssLabelMandatory">iPay88 Merchant Code:</td>
                                                <td className="valueCol">
                                                    <input
                                                        className="cssTextBox" name="merchant_code"
                                                        value={school.merchant_code} maxLength={20}
                                                        onChange={handleChange} style={{ width: "97%" }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="labelCol cssLabelMandatory">iPay88 Merchant Key:</td>
                                                <td className="valueCol">
                                                    <input
                                                        className="cssTextBox" name="merchant_key"
                                                        value={school.merchant_key} maxLength={20}
                                                        onChange={handleChange} style={{ width: "97%" }}
                                                    />
                                                </td>
                                            </tr>
                                        </>
                                    )}

                                    {/* ── Access Control section (SCH / LIB only) ── */}
                                    {showACL && (
                                        <>
                                            <tr>
                                                <td colSpan={2} align="center"
                                                    className="cssContentTitle"
                                                    style={{ backgroundColor: "teal", justifyContent: "center" }}
                                                >
                                                    Access Control
                                                </td>
                                            </tr>

                                            <tr className="aclSection" style={{ display: "none" }}>
                                                {/* Authenticate IP hidden by default (display:none in VB) */}
                                                <td colSpan={2}>
                                                    <label>
                                                        <input
                                                            type="checkbox" name="authenticate_ip"
                                                            checked={school.authenticate_ip}
                                                            onChange={handleChange}
                                                        /> Authenticate IP also
                                                    </label>
                                                </td>
                                            </tr>

                                            <tr className="aclSection">
                                                <td colSpan={2}>
                                                    <label>
                                                        <input
                                                            type="checkbox" name="allow_direct_home_use"
                                                            checked={school.allow_direct_home_use}
                                                            onChange={handleChange}
                                                        /> Authorised to allow students to use from Home
                                                    </label>
                                                </td>
                                            </tr>

                                            <tr className="aclSection">
                                                <td colSpan={2}>
                                                    <label>
                                                        <input
                                                            type="checkbox" name="allow_home_work"
                                                            checked={school.allow_home_work}
                                                            onChange={handleChange}
                                                        /> Authorised to allow students to do Home Work
                                                    </label>
                                                </td>
                                            </tr>

                                            <tr className="aclSection">
                                                <td colSpan={2}>
                                                    <label>
                                                        <input
                                                            type="checkbox" name="school_can_access_from_anywhere"
                                                            checked={school.school_can_access_from_anywhere}
                                                            onChange={handleChange}
                                                        /> School/Library users can login from anywhere
                                                    </label>
                                                </td>
                                            </tr>

                                            <tr className="aclSection">
                                                <td colSpan={2} align="center" style={{ height: 30, verticalAlign: "middle" }}>
                                                    Access to the site is restricted as below (Blank = no restriction)
                                                </td>
                                            </tr>

                                            <tr className="aclSection">
                                                <td>From (dd/MM/yyyy):</td>
                                                <td>
                                                    <input
                                                        className="cssTextBox" name="access_start_date"
                                                        value={school.access_start_date} maxLength={10}
                                                        onChange={handleChange}
                                                        style={{ width: 80 }}
                                                    />
                                                    &nbsp;&nbsp;To&nbsp;&nbsp;
                                                    <input
                                                        className="cssTextBox" name="access_end_date"
                                                        value={school.access_end_date} maxLength={10}
                                                        onChange={handleChange}
                                                        style={{ width: 80 }}
                                                    />
                                                    &nbsp;And
                                                </td>
                                            </tr>

                                            <tr className="aclSection">
                                                <td>Between (HH:mm):</td>
                                                <td>
                                                    <input
                                                        className="cssTextBox" name="access_from_time"
                                                        value={school.access_from_time} maxLength={5}
                                                        onChange={handleChange}
                                                        style={{ width: 80 }}
                                                    />
                                                    &nbsp;&nbsp;To&nbsp;&nbsp;
                                                    <input
                                                        className="cssTextBox" name="access_to_time"
                                                        value={school.access_to_time} maxLength={5}
                                                        onChange={handleChange}
                                                        style={{ width: 80 }}
                                                    />
                                                    &nbsp;And
                                                </td>
                                            </tr>

                                            <tr className="aclSection" style={{ borderTop: "solid 1px black" }}>
                                                <td colSpan={2} align="center" style={{ height: 35, verticalAlign: "middle" }}>
                                                    On:&nbsp;
                                                    {DAYS.map((day, idx) => (
                                                        <label key={day} style={{ marginRight: 8 }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={isDayChecked(idx)}
                                                                onChange={e => setDay(idx, e.target.checked)}
                                                            /> {day}
                                                        </label>
                                                    ))}
                                                </td>
                                            </tr>
                                        </>
                                    )}

                                    {/* ── IP List section (SCH / LIB only) ── */}
                                    {showIP && (
                                        <>
                                            <tr>
                                                <td colSpan={2} align="center"
                                                    className="cssContentTitle"
                                                    style={{ backgroundColor: "teal" }}
                                                >
                                                    <span style={{ flex: 1 }}>List Of IP Address</span>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <button className="cssButtonForAdmin" onClick={handleAddIP}>Add</button>
                                                    &nbsp;
                                                    <button
                                                        className="cssButtonForAdmin"
                                                        onClick={handleDeleteIP}
                                                    >Delete</button>
                                                    &nbsp;
                                                    <button className="cssButtonForAdmin" onClick={handleEditIP}>Edit</button>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td colSpan={2} valign="top" style={{ height: 40 }}>
                                                    <div style={{ overflow: "auto" }}>
                                                        <table className="cssGridView" cellPadding={3} style={{ width: "100%" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th className="cssGridViewHeader" style={{ width: "25%" }}>Start IP#</th>
                                                                    <th className="cssGridViewHeader" style={{ width: "25%" }}>End IP#</th>
                                                                    <th className="cssGridViewHeader" style={{ width: "25%" }}>Start IP Address</th>
                                                                    <th className="cssGridViewHeader" style={{ width: "20%" }}>End IP Address</th>
                                                                    {/* ID column hidden (display:none in VB) */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ips.map((ip, idx) => (
                                                                    <tr
                                                                        key={ip.id}
                                                                        className={
                                                                            selectedIPRow === idx
                                                                                ? "cssGridSelRow"
                                                                                : idx % 2 === 0 ? "cssGridRow" : "cssGridAltRow"
                                                                        }
                                                                        onClick={() => selectIPRow(idx, ip.id)}
                                                                    >
                                                                        <td>{ip.start_ip}</td>
                                                                        <td>{ip.end_ip}</td>
                                                                        <td>{ip.start_ip_address}</td>
                                                                        <td>{ip.end_ip_address}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )}

                                </tbody>
                            </table>
                        </td>

                        {/* ════ RIGHT COLUMN — Products panel ════ */}
                        <td className="rightCol" valign="top">



                            <div id="divProd">
                                <table cellSpacing={1} cellPadding={3} border={0} style={{ width: "97%" }}>
                                    <thead>
                                        <tr className="prodHeader">
                                            <td align="left" style={{ width: "15%" }}>Curriculum</td>
                                            <td align="center" style={{ width: "10%" }}>ProdID</td>
                                            <td align="left" style={{ width: "50%", paddingLeft: 2 }}>Product Description</td>
                                            <td align="left" style={{ width: "15%" }}>Subject</td>
                                            <td align="center" style={{ width: "10%" }}>Select</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {visibleProducts.map((p, idx) => {
                                            const isAssigned = p.no_of_lic_purchased !== null
                                            const bclr = idx % 2 === 0 ? "#F4FAFF" : "#EAEEEE"
                                            return (
                                                <tr
                                                    key={p.prod_id}
                                                    style={{
                                                        backgroundColor: bclr,
                                                        color: isAssigned ? "blue" : "black",
                                                        fontWeight: isAssigned ? "bold" : "normal"
                                                    }}
                                                >
                                                    <td align="left">{p.curriculum}</td>
                                                    <td align="center">{p.prod_id}</td>
                                                    <td align="left" style={{ paddingLeft: 2 }}>{p.prod_desc}</td>
                                                    <td align="left">{p.subject}</td>
                                                    <td align="center">
                                                        <input
                                                            type="checkbox"
                                                            checked={isAssigned}
                                                            onChange={e => toggleProductAssignment(p.prod_id, e.target.checked)}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* ── Bottom bar — Save / Cancel ── */}
            <table style={{ width: "100%" }}>
                <tbody>
                    <tr>
                        <td className="bottomBar">
                            {/* {updateMessage && <span className="updateMsg">{updateMessage}&nbsp;&nbsp;</span>} */}
                            {/* {errorMsg && <span className="errorMsg">{errorMsg}&nbsp;&nbsp;</span>} */}
                            <button
                                className="cssButtonWithBorder"
                                onClick={handleSave}
                                disabled={isLoading}
                                style={{
                                    width: 100,
                                    opacity: isLoading ? 0.6 : 1,
                                    cursor: isLoading ? "not-allowed" : "pointer"
                                }}
                            >
                                Save
                            </button>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button
                                className="cssButtonWithBorder"
                                onClick={handleCancel}
                                disabled={isLoading}
                                style={{
                                    width: 100,
                                    opacity: isLoading ? 0.6 : 1,
                                    cursor: isLoading ? "not-allowed" : "pointer"
                                }}
                            >
                                Cancel
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}